import React, { Fragment, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { store as mainStore } from '../../../../../store';
import useRules from "../../../../../hooks/useRules"

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '&>button:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));

const DriversActionsButtons = () => {
  const history = useHistory();
  const classes = useStyles();
  const [rules,hasRule,isAdmin] = useRules();
  const {
    state: {
      Auth: {
        profile: { username },
      },
    },
  } = useContext(mainStore);

  const handleClick = (role) => {
    history.push(`/protected/admin/users/add/${role}`);
  };
  const handleOpenImportDriversPage = () => {
    history.push(`/protected/admin/users/import/drivers`);
  };

  return (
    <div className={classes.buttons}>
      {hasRule('users_add_drivers_from_excel') && (
        <Button
          variant="contained"
          size="small"
          color="secondary"
          onClick={handleOpenImportDriversPage}
          endIcon={<AttachFileIcon />}
        >
          ایمپورت رانندگان از فایل
        </Button>
      )}
      
      {hasRule('users_add_driver') && <Button
        variant="contained"
        size="small"
        color="secondary"
        onClick={() => handleClick('driver')}
      >
        افزودن راننده
      </Button>}
    </div>
  );
};

export default React.memo(DriversActionsButtons);
